import { Scrollbar } from '../core';

function getCurrentStep() {
  return $('.form-steps__step[aria-expanded="true"]');
}

// Mobile (colonne unique, md down) : la zone formulaire scrolle avec la page
// plutôt que via un scroll interne. Aligné sur le breakpoint md du layout.
function isMobileForm() {
  return window.matchMedia('(max-width: 767.98px)').matches;
}

function formScroll() {
  // Sur mobile, on laisse le flux de page naturel : aucune scrollbar interne.
  if (isMobileForm()) {
    return;
  }

  $('.form-step__field-wrapper').each(function() {
    let $el = $(this);

    // check if scrollbar already exists
    let scrollbar = $el.data('scrollbar');

    if (scrollbar) {
      // update existing scrollbar
      if (typeof scrollbar.update === 'function') {
        scrollbar.update();
      }
    } else {
      // create new scrollbar
      scrollbar = new Scrollbar($el, {
        direction: 'vertical',
        desktop: true,
        mobile: false,
      });
      $el.data('scrollbar', scrollbar);
    }
  });
}

function validateCurrentStep($step = null) {
  const $currentStep = $step || getCurrentStep();
  if (!$currentStep.length) return;

  const $requiredFields = $currentStep.find('[required]');
  let allValid = true;
  const checkedRadios = new Set();

  $requiredFields.each(function () {
    const $field = $(this);

    if ($field.is(':radio')) {
      const name = $field.attr('name');
      if (checkedRadios.has(name)) return;

      if (!$currentStep.find(`input[name="${name}"]:checked`).length) {
        allValid = false;
        return false;
      }

      checkedRadios.add(name);
    } else if (!$field.val()) {
      allValid = false;
      return false;
    }
  });

  // Check if ALL fields (not just required) are filled
  let allFilled = true;
  $currentStep.find('input, select, textarea').not('[type="hidden"], [type="submit"], button').each(function () {
    const $field = $(this);
    if ($field.is(':radio')) {
      const name = $field.attr('name');
      if (!$currentStep.find(`input[name="${name}"]:checked`).length) {
        allFilled = false;
      }
    } else if ($field.is(':checkbox')) {
      // checkboxes are optional
    } else if ($field.is('select')) {
      if (!$field.val() || $field.val() === 'none') {
        allFilled = false;
      }
    } else if (!$field.val()) {
      allFilled = false;
    }
  });

  const $footer = $currentStep.find('.row-footer');
  const $next = $footer.find('.field__next');
  $next.toggleClass('--locked', !allValid);
  $next.toggleClass('--ready', allValid && allFilled);

  if ($currentStep.is(':last-of-type')) {
    $('.field__submit').toggleClass('--locked', !allValid);
  }
}

function observeStepChanges(callback) {
  const target = document.querySelector('.form-steps__steps');
  if (!target) return;

  new MutationObserver(() => {
    callback(getCurrentStep());
  }).observe(target, {
    attributes: true,
    subtree: true,
    attributeFilter: ['aria-expanded'],
  });
}

function initRadioTabbing() {
  let radioClickedByMouse = false;

  // Track mouse clicks on radios
  $('.builder-form').on('mousedown', 'input[type="radio"]', function() {
    radioClickedByMouse = true;
  });

  // On focus (Tab into group): select the focused radio
  $('.builder-form').on('focus', 'input[type="radio"]', function() {
    if (!radioClickedByMouse) {
      $(this).prop('checked', true).trigger('change');
    }
  });

  // Auto-advance on click only (not keyboard). The step that sends the request
  // waits for its « Envoyer » button.
  $('.builder-form').on('change', 'input[type="radio"]', function() {
    if (radioClickedByMouse) {
      radioClickedByMouse = false;
      const $step = $(this).closest('.form-steps__step');
      if ($step.find('.field__next').hasClass('--submit')) return;
      setTimeout(() => $step.find('.field__next').trigger('click'), 100);
    }
  });

  // Enter on a radio: submit the step
  $('.builder-form').on('keydown', 'input[type="radio"]', function(e) {
    if (e.key !== 'Enter') return;
    e.preventDefault();
    const $step = $(this).closest('.form-steps__step');
    if ($step.is(':last-of-type')) {
      $step.closest('form').find('.field__submit').trigger('click');
    } else {
      $step.find('.field__next').trigger('click');
    }
  });

  // Enter on last field of a step: trigger next step or submit
  $('.builder-form').on('keydown', 'input:not([type="radio"]), select, textarea', function(e) {
    if (e.key !== 'Enter') return;
    if ($(this).is('textarea')) return;

    const $step = $(this).closest('.form-steps__step');
    if (!$step.length) return;

    const $fields = $step.find('input, select, textarea').not('[type="hidden"], [type="submit"], [type="radio"], button');
    const isLast = $fields.index(this) === $fields.length - 1;

    if (isLast) {
      e.preventDefault();
      if ($step.is(':last-of-type')) {
        $step.closest('form').find('.field__submit').trigger('click');
      } else {
        $step.find('.field__next').trigger('click');
      }
    }
  });
}

function initValidationWatcher() {
  const form = $('.builder-form');
  const lockBtns = $('.field__next, .field__submit').addClass('--locked');

  form.on('input change', '.form-steps__step[aria-expanded="true"] input, .form-steps__step[aria-expanded="true"] select, .form-steps__step[aria-expanded="true"] textarea', () => {
    validateCurrentStep();
  });

  observeStepChanges(($newStep) => {
    validateCurrentStep($newStep);
    formScroll();

    // Mobile : on remonte en haut de la zone formulaire à chaque changement
    // d'étape (sur desktop, le scroll interne se réinitialise déjà).
    if (isMobileForm()) {
      const $anchor = $newStep.closest('.form-steps');
      const $target = $anchor.length ? $anchor : $newStep;
      $target[0].scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    // Move focus to step container so next Tab reaches the first option
    setTimeout(() => $newStep[0].focus({ preventScroll: true }), 100);
  });

  validateCurrentStep();
  formScroll();
}

export default {
  init() {
    initValidationWatcher();
    initRadioTabbing();
  }
};

export { formScroll };
